import axiosInstance from '@/services/api/axiosInstance';

/**
 * POST /user/discounts/check — what would this code do to this price?
 *
 * Preview only. Nothing is reserved: the use is spent when the payment
 * settles, so a client can check a code and walk away without burning it.
 *
 * The response is the server's arithmetic, not ours — `{ valid, reason,
 * originalToman, discountToman, finalToman }`. The pay endpoints re-quote
 * the same code from the same table, so the figure shown here is the figure
 * charged; we never send an amount and the server never trusts one.
 *
 * @param {{code: string, amountToman: number, context?: string, clinicCode?: string}} args
 */
export async function check({ code, amountToman, context, clinicCode }) {
  const res = await axiosInstance.post('/user/discounts/check', {
    code, amountToman, context: context || 'all', clinicCode: clinicCode || null,
  });
  return res.data.data ?? res.data;
}

export const discountsApi = { check };
export default discountsApi;
